const clamp = (currentValue: number, minimumValue: number, maximumValue: number): number => {
  return Math.max(Math.min(currentValue, maximumValue), minimumValue);
};

export default clamp;
